<template>
  <div class="saleSampleProfit">
    <h2>利润核算单</h2>
    <el-form :inline="true">
      <el-form-item label="客户">
        <el-select v-model="searchParam.custom" filterable style="width: 120px;" clearable>
          <el-option v-for='customItem in show.customList' :key="customItem.id" :label="customItem.value" :value="customItem.value" />
        </el-select>
      </el-form-item>
      <el-form-item label="核算区间">
        <el-date-picker v-model="searchParam.dates" type="daterange" start-placeholder="起" end-placeholder="止" style="width: 220px;" />
      </el-form-item>
      <el-form-item>
        <el-button-group>
          <el-button type="primary" @click="commitFindList()">搜索</el-button>
          <el-button type="info" @click="exportExcel()">导出</el-button>
          <el-button @click="resetSearchParam()">重置</el-button>
        </el-button-group>
      </el-form-item>
      <el-form-item>
        <el-button-group>
          <el-button type="danger" :disabled="!(show.selected.length >= 1)" @click="del()">删除</el-button>
        </el-button-group>
      </el-form-item>
    </el-form>
    <el-table :data="data.list" @selection-change="selectionChange()" ref="tabRef" border show-summary :summary-method="summary" style="height: calc(100vh - 220px);">
      <el-table-column type="selection" width="55" align="center" />
      <el-table-column width="160" align="center">
        <template #default="scope">
          <el-link type="primary" @click="gotoSaleSampleProfitAsMix(scope.row)">配比指标</el-link>
          <el-link type="primary" @click="gotoSaleSampleProfitAsProduct(scope.row)" style="margin-left: 10px;">配比吨数</el-link>
        </template>
      </el-table-column>
      <el-table-column label="核算单号" width="100" align="center">
        <template #default="scope">
          <el-text>{{ scope.row.id }}</el-text>
        </template>
      </el-table-column>
      <el-table-column prop="operateDatetime" label="核算操作时间" width="180" show-overflow-tooltip>
        <template #default="scope">
          {{ util.parseTime(scope.row.operateDatetime) }}
        </template>
      </el-table-column>
      <el-table-column prop="custom" label="客户" width="120" show-overflow-tooltip />
      <el-table-column prop="dateFrom" label="核算起始" width="120" show-overflow-tooltip />
      <el-table-column prop="dateTo" label="核算截止" width="120" show-overflow-tooltip />
      <el-table-column prop="sendQuantity" label="原发数量" width="120" show-overflow-tooltip align="right">
        <template #default="scope">
          {{ math.formatNumber(scope.row.sendQuantity) }}
        </template>
      </el-table-column>
      <el-table-column prop="sampleQuantity" label="送达数量" width="120" show-overflow-tooltip align="right">
        <template #default="scope">
          {{ math.formatNumber(scope.row.sampleQuantity) }}
        </template>
      </el-table-column>
      <el-table-column prop="saleProfitAmount" label="销售净利润" width="120" show-overflow-tooltip align="right">
        <template #default="scope">
          {{ math.formatNumber(scope.row.saleProfitAmount) }}
        </template>
      </el-table-column>
      <el-table-column prop="businessProfitPrice" label="测算利润单价" width="120" show-overflow-tooltip align="right">
        <template #default="scope">
          {{ math.formatNumber(scope.row.businessProfitPrice) }}
        </template>
      </el-table-column>
      <el-table-column prop="profitPrice" label="净利润单价" width="120" show-overflow-tooltip align="right">
        <template #default="scope">
          {{ math.formatNumber(scope.row.profitPrice) }}
        </template>
      </el-table-column>
      <el-table-column prop="settlePrice" label="结算单价" width="120" show-overflow-tooltip align="right">
        <template #default="scope">
          {{ math.formatNumber(scope.row.settlePrice) }}
        </template>
      </el-table-column>
      <el-table-column prop="procureProductPrice" label="采购单价" width="120" show-overflow-tooltip align="right">
        <template #default="scope">
          {{ math.formatNumber(scope.row.procureProductPrice) }}
        </template>
      </el-table-column>
      <el-table-column prop="procureTransportPrice" label="上游运输单价" width="120" show-overflow-tooltip align="right">
        <template #default="scope">
          {{ math.formatNumber(scope.row.procureTransportPrice) }}
        </template>
      </el-table-column>
      <el-table-column prop="saleTransportPrice" label="下游运输单价" width="120" show-overflow-tooltip align="right">
        <template #default="scope">
          {{ math.formatNumber(scope.row.saleTransportPrice) }}
        </template>
      </el-table-column>
      <el-table-column prop="dispatchPrice" label="单位调度费" width="120" show-overflow-tooltip align="right">
        <template #default="scope">
          {{ math.formatNumber(scope.row.dispatchPrice) }}
        </template>
      </el-table-column>
      <el-table-column prop="salePriceTransportTax" label="单位运费补税" width="120" show-overflow-tooltip align="right">
        <template #default="scope">
          {{ math.formatNumber(scope.row.salePriceTransportTax) }}
        </template>
      </el-table-column>
      <el-table-column prop="salePriceProfitTax" label="单位利润补税" width="120" show-overflow-tooltip align="right">
        <template #default="scope">
          {{ math.formatNumber(scope.row.salePriceProfitTax) }}
        </template>
      </el-table-column>
      <el-table-column prop="salePriceSuodeTax" label="单位所得税" width="120" show-overflow-tooltip align="right">
        <template #default="scope">
          {{ math.formatNumber(scope.row.salePriceSuodeTax) }}
        </template>
      </el-table-column>
      <el-table-column prop="salePriceEstimatedCost" label="单位预估费用" width="120" show-overflow-tooltip align="right">
        <template #default="scope">
          {{ math.formatNumber(scope.row.salePriceEstimatedCost) }}
        </template>
      </el-table-column>
      <el-table-column prop="diweifareliangKc" label="平均热大卡" width="120" show-overflow-tooltip align="right">
        <template #default="scope">
          {{ math.formatNumber(scope.row.diweifareliangKc) }}
        </template>
      </el-table-column>
      <el-table-column prop="quanliu" label="平均全硫" width="120" show-overflow-tooltip align="right">
        <template #default="scope">
          {{ math.formatNumber(scope.row.quanliu) }}
        </template>
      </el-table-column>
      <el-table-column prop="huifafen" label="平均挥发分" width="120" show-overflow-tooltip align="right">
        <template #default="scope">
          {{ math.formatNumber(scope.row.huifafen) }}
        </template>
      </el-table-column>
      <el-table-column prop="sumSalePriceTax" label="单位税金合计" width="120" show-overflow-tooltip align="right">
        <template #default="scope">
          {{ math.formatNumber(scope.row.sumSalePriceTax) }}
        </template>
      </el-table-column>
      <el-table-column prop="salePriceZengzhiTax" label="单位增值税" width="120" show-overflow-tooltip align="right">
        <template #default="scope">
          {{ math.formatNumber(scope.row.salePriceZengzhiTax) }}
        </template>
      </el-table-column>
      <el-table-column prop="salePriceFujiaTax" label="单位附加税" width="120" show-overflow-tooltip align="right">
        <template #default="scope">
          {{ math.formatNumber(scope.row.salePriceFujiaTax) }}
        </template>
      </el-table-column>
      <el-table-column prop="salePriceYinhuaTax" label="单位印花税" width="120" show-overflow-tooltip align="right">
        <template #default="scope">
          {{ math.formatNumber(scope.row.salePriceYinhuaTax) }}
        </template>
      </el-table-column>
    </el-table>
    <div style="height: 10px;" />
  </div>
</template>

<script setup>
import { reactive, ref } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage, ElMessageBox } from 'element-plus'
import api from '../../apis/api'
import apiNative from '../../apis/apiNative'
import cache from '../../utils/cache'
import util from '../../utils/util'
import math from '../../utils/math'

const router = useRouter()
const tabRef = ref()

const data = reactive({
  accumulate: {},
  list: [],
})

const show = reactive({
  selected: [],
  customList: [],
})
api.get('/backend/dict/getByCode', { params: { code: 'custom' } }).then(res => {
  show.customList = res.dictList
})

const searchParam = reactive({})
const resetSearchParam = () => {
  searchParam.custom = null
  searchParam.dates = []
}
resetSearchParam()

const getPageParam = () => {
  const params = {}
  if (searchParam.custom) {
    params.custom = searchParam.custom
  } else {
    ElMessage.warning('请选择客户')
    return
  }
  if (searchParam.dates && searchParam.dates.length == 2) {
    params.dateFromGe = util.parseTime(searchParam.dates[0], '{y}-{m}-{d}')
    params.dateToLe = util.parseTime(searchParam.dates[1], '{y}-{m}-{d}')
  } else {
    ElMessage.warning('请选择时间区间')
    return
  }
  return params
}

const commitFindList = () => {
  const params = getPageParam()
  if (!params) {
    return
  }
  api.get('/backend/saleSample/getProfitList', { params: params }).then(res => {
    data.list = res.list
    data.accumulate = res.accumulate
  })
}

const beforeSearchParam = cache.getObject(cache.keys.pageParam + 'saleSampleProfit')
if (beforeSearchParam) {
  Object.assign(searchParam, beforeSearchParam)
  cache.setObject(cache.keys.pageParam + 'saleSampleProfit', null)
  commitFindList()
}

const summary = () => {
  return [
    '合计',
    '',
    '',
    '',
    '',
    '',
    '',
    math.formatNumber(data.accumulate.sendQuantity),
    math.formatNumber(data.accumulate.sampleQuantity),
    math.formatNumber(data.accumulate.saleProfitAmount),
    math.formatNumber(data.accumulate.businessProfitPrice),
    math.formatNumber(data.accumulate.profitPrice),
    math.formatNumber(data.accumulate.settlePrice),
    math.formatNumber(data.accumulate.procureProductPrice),
    math.formatNumber(data.accumulate.procureTransportPrice),
    math.formatNumber(data.accumulate.saleTransportPrice),
    math.formatNumber(data.accumulate.dispatchPrice),
    math.formatNumber(data.accumulate.salePriceTransportTax),
    math.formatNumber(data.accumulate.salePriceProfitTax),
    math.formatNumber(data.accumulate.salePriceSuodeTax),
    math.formatNumber(data.accumulate.salePriceEstimatedCost),
    math.formatNumber(data.accumulate.diweifareliangKc),
    math.formatNumber(data.accumulate.quanliu),
    math.formatNumber(data.accumulate.huifafen),
    math.formatNumber(data.accumulate.sumSalePriceTax),
    math.formatNumber(data.accumulate.salePriceZengzhiTax),
    math.formatNumber(data.accumulate.salePriceFujiaTax),
    math.formatNumber(data.accumulate.salePriceYinhuaTax),
  ]
}

const selectionChange = () => {
  show.selected = tabRef.value.getSelectionRows()
}

const del = () => {
  const ids = tabRef.value.getSelectionRows().map(saleSampleProfit => saleSampleProfit.id)
  ElMessageBox.confirm('', {
    title: '确认删除',
    message: '将要删除选中的 ' + ids.length + ' 项。',
    autofocus: false,
    confirmButtonText: '确认',
    cancelButtonText: '取消'
  }).then(() => {
    api.post('/backend/saleSample/delProfit', { ids: ids }).then(() => {
      ElMessage.success('删除成功')
      commitFindList()
    })
  })
}

const gotoSaleSampleProfitAsMix = (row) => {
  cache.setObject(cache.keys.pageParam + 'saleSampleProfit', searchParam)
  cache.setObject(cache.keys.pageParam + 'saleSampleProfitAsMix', { id: row.id })
  router.push('/saleSampleProfitAsMix')
}

const gotoSaleSampleProfitAsProduct = (row) => {
  cache.setObject(cache.keys.pageParam + 'saleSampleProfit', searchParam)
  cache.setObject(cache.keys.pageParam + 'saleSampleProfitAsProduct', { id: row.id })
  router.push('/saleSampleProfitAsProduct')
}

const exportExcel = () => {
  const params = getPageParam()
  if (!params) {
    return
  }
  ElMessageBox.confirm('', {
    title: '确认导出',
    message: '将要按照当前选择的查询条件进行导出。',
    autofocus: false,
    confirmButtonText: '确认',
    cancelButtonText: '取消'
  }).then(() => {
    ElMessage.success('正在导出！如果数据量大可能时间较长，请耐心等待。')
    apiNative.get('/backend/saleSample/exportProfitList', {
      params: params,
      responseType: 'blob'
    }).then(res => {
      ElMessage.success('开始下载')
      util.downloadFile(res, '利润核算单' + util.parseTime(new Date(), '{y}{m}{d}{h}{i}{s}'), 'xlsx')
    }).catch(() => {
      ElMessage.error('导出失败，请联系系统管理员')
    })
  })
}
</script>

<style lang="less"></style>